import React, { useEffect } from "react";

/**
 * MobileAuthBridge runs inside the external mobile browser (Safari/Chrome).
 * It clears the externalMobileAuth sticky and cookie in that browser context
 * and immediately deep-links back to the native app using the provided token.
 *
 * Route: /mobile/auth-bridge?token=...
 */
export const MobileAuthBridge: React.FC = () => {
  useEffect(() => {
    try {
      // Clear the durable sticky in this browser context
      window.localStorage?.removeItem("externalMobileAuth");
    } catch (_) {
      // noop
    }
    // Best-effort: ask server to clear cookie fallback
    try {
      fetch("/identity/clear-external-mobile-auth", {
        credentials: "include",
        cache: "no-store",
      }).catch(() => {
        // ignore
      });
    } catch (_) {
      // noop
    }

    // Extract token and deep-link back to the native app
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      const deeplink = `minpipe://auth-callback?token=${encodeURIComponent(
        token
      )}`;
      // Use replace so back won't return here
      window.location.replace(deeplink);
    } else {
      // If no token, just go to root
      window.location.replace("/");
    }
  }, []);

  return null;
};
